import React from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';
import TinySegmenter from 'tiny-segmenter';

const segmenter = new TinySegmenter();

const InlinedSpan = styled.span`
  display: inline-block;
`;

/**
 * Segmented Translate component
 * Automatically segments text so that it is rendered more cleanly in browser
 */

const SegmentedTranslate = ({ id, data }) => (
  <Translate>
    {({ translate }) => {
      return segmenter
        .segment(translate(id, data))
        .map((text, index) => <InlinedSpan key={index}>{text}</InlinedSpan>);
    }}
  </Translate>
);
export default SegmentedTranslate;
